import React from "react";

function DurationForRent() {
  return (
    <div className="type-of-sale">
      <h5>Set Duration</h5>{" "}
      <div className="regi__type mb-3 d-flex justify-content-between">
        <div className="input input--secondary mt-3 select-type">
          <label for="methodSelect">Select Type</label>
          <select className="type__select" id="methodSelect">
            <option value="day">Days</option>
            <option value="month">Months</option>
            <option value="years">Years</option>
          </select>
        </div>
        <div className="input input--secondary mt-3 select-number">
          <label for="number">Set Number</label>
          <div className="input-price">
            <input
              type="number"
              name="number"
              min="1"
              id="number"
              placeholder="Enter Number"
              required="required"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DurationForRent;
